// extracted by mini-css-extract-plugin
module.exports = {"list":"style_list__b6gDY","light":"style_light__2olUy","used-in-white-card":"style_used-in-white-card__2rdV4","draggable":"style_draggable__3p5_K"};